"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayment = void 0;
var getPayment = function (carPrice, initialContribution, creditTerm, interestRate) {
    if (!carPrice)
        return 0;
    var initialContributionAmount = (initialContribution / 100) * carPrice;
    var loanAmount = carPrice - initialContributionAmount;
    if (interestRate === 0) {
        return loanAmount / creditTerm;
    }
    var monthlyRate = interestRate / 100 / 12;
    var monthlyPayment = loanAmount * (monthlyRate / (1 - Math.pow(1 + monthlyRate, -creditTerm)));
    return monthlyPayment;
};
exports.getPayment = getPayment;
